import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[roundTo]',
    standalone: false
})
export class RoundToDirective implements OnInit {
  @Input('roundTo') decimals = 2;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit(): void {
    this.roundValue();
  }

  @HostListener('blur')
  onBlur(): void {
    this.roundValue();
  }

  private roundValue(): void {
    const input = this.el.nativeElement;
    const value = parseFloat(input.value);

    if (!isNaN(value)) {
      const factor = Math.pow(10, this.decimals);
      const rounded = Math.round(value * factor) / factor;
      input.value = String(rounded);
    }
  }
}
